module.exports = __webpack_public_path__ + "assets/img/chevron-left.3f500b06.svg";